var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.243,
    height: 37.242,
    viewBox: "0 0 37.243 37.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-eye-off",
    "data-name": "Icon feather-eye-off",
    transform: "translate(0.621 0.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11378",
    "data-name": "Path 11378",
    d: "M26.91,26.91A15.105,15.105,0,0,1,18,30C7.5,30,1.5,18,1.5,18A27.675,27.675,0,0,1,9.09,9.09m5.76-2.73A13.68,13.68,0,0,1,18,6C28.5,6,34.5,18,34.5,18a27.75,27.75,0,0,1-3.24,4.785m-10.08-1.6a4.5,4.5,0,1,1-6.36-6.36",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11379",
    "data-name": "Path 11379",
    d: "M1.5,1.5l33,33",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eyeClose.48df9e6a4d233955b5daf23d37dacaa0.svg";
export { ForwardRef as ReactComponent };